import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchPuttPerformanceChart,
 } from 'Actions';

class ViewChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            loader:false,
            viewdiv:true,
            contact:'',
            shotstring:'',
            showModal:false,
            distance:'',
            putttype:'',
            adddiv:false,

        };

        
    } 
    
    handleChange(e, val){

        if(val==1){
            var distance=e.target.value;
            var putttype=this.state.putttype;
            this.setState({ distance:distance });
        }else if(val==2){
            var putttype=e.target.value;
            var distance=this.state.distance;
            this.setState({ putttype:putttype });
        }
        
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        this.props.fetchPuttPerformanceChart(student, stdate, eddate, distance, putttype).then((data) => {   
                        
           

        }); 
    }
    
    


render() {

    const { puttperformancechart,  loading} = this.props; 
    const datacount=puttperformancechart.length;
    const scatterData = puttperformancechart.chartvalue;  
    const avgputt = puttperformancechart.avgputt;     
    const data1 = [       
        { x: 'RIGHT', y: puttperformancechart.missright },
        { x: 'LEFT', y: puttperformancechart.missleft },
        { x: 'LONG', y: puttperformancechart.misslong },
        { x: 'SHORT', y: puttperformancechart.missshot },
    ];
    const data1max=puttperformancechart.highval; 
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip" style={{backgroundColor:"#fff", padding:"10px", fontSize:"10px"}}>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label1}`}=<strong>{`${payload[0].payload?.val1}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label2}`}=<strong>{`${payload[0].payload?.val2}`}</strong></div>
            </div>
          );
        }
      
        return null;
    };

    
    const CustomBarLabel = ({ payload, x, y, value }) => {
        return <text x={x+10} y={y} dy={-6} fill="#757474" textAnchor="middle" >{value}%</text>;
    }

    return(
        <div>   
             {this.state.viewdiv &&
            <RctCollapsibleCard>
                <div className="row">                    
                    <div className="col-sm-12 col-lg-3">
                        <h2>PUTT PERFORMANCE REPORT</h2>                         
                    </div>
                    <div className="col-sm-12 col-lg-8">
                        <div className="row">
                        <div className="col-sm-12 col-lg-1">
                             <h5 style={{marginTop:"10px"}}>Distance</h5>
                        </div>    
                        <div className="col-sm-12 col-lg-4">                        
                        <select  name="distance" id="distance" className="form-control form-control-alternative" onChange={e => this.handleChange(e, 1)} required>
                            <option value="">All</option>
                            <option value="1">0-3</option>
                            <option value="2">4-6</option>
                            <option value="3">7-10</option>
                            <option value="4">11-15</option>
                            <option value="5">16-20</option>
                            <option value="6">21-25</option>
                            <option value="7">26-30</option>
                            <option value="8">31-35</option>                                            
                            <option value="9">36-40</option>
                            <option value="10">41-50</option>
                            <option value="11">51-100</option>
                        </select>
                        </div>
                        <div className="col-sm-12 col-lg-1">
                             <h5 style={{marginTop:"10px"}}>Putt type</h5>
                        </div>    
                        <div className="col-sm-12 col-lg-4">                        
                        <select  name="putttype" id="putttype" className="form-control form-control-alternative" onChange={e => this.handleChange(e, 2)} required>
                            <option value="">All</option>
                            <option value="1">Straight flat</option>
                            <option value="2">Straight uphill</option> 
                            <option value="3">Straight downhill</option> 
                            <option value="4">Right to left flat</option> 
                            <option value="5">Right to left uphill</option> 
                            <option value="6">Right to left downhill</option> 
                            <option value="7">Left to right flat</option> 
                            <option value="8">Left to right uphill</option> 
                            <option value="9">Left to right downhill</option>                                             
                        </select>
                        </div>
                        <div className="col-sm-12 col-lg-2">
                            <div><a onClick={this.props.onClick} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.props.onClick1}><span class="icon-list"></span> List</a></div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-5">
                            
                        <ScatterChart
                        width={450}
                        height={300}
                        margin={{
                            top: 30,
                            right: 50,
                            bottom: 20,
                            left: 20
                        }}
                        
                        >
                        <text x={450 / 2} y={10} fill="gray" textAnchor="top" dominantBaseline="central">
                            <tspan fontSize="14">Long</tspan>
                        </text>
                        <text x={410} y={140} fill="gray" textAnchor="right" dominantBaseline="center">
                            <tspan fontSize="14">Right</tspan>
                        </text>     
                        <CartesianGrid />
                        <XAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-40, -30, -20, -10, 0, 10, 20, 30, 40]} label={{value:"Short", position:"bottom"}} dataKey="x" unit="ft" /> 
                        <YAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-40, -30, -20, -10, 0, 10, 20, 30, 40]} label={{value:"Left", position: "insideLeft"}} dataKey="y" unit="ft" />
                        
                        <Scatter name="A school" data={scatterData} fill="#8884d8">
                            {scatterData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} text="sdfdsf" label="sdfsfd" dataKey={entry}/>
                            ))}
                        </Scatter>
                        <Tooltip cursor={{ strokeDasharray: "3 3" }} content={<CustomTooltip/>}/>
                        <ReferenceLine y={0} stroke="#000000" />
                        <ReferenceLine x={0} stroke="#000000" />
                        <ReferenceLine
                            segment={[
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            }
                            ]}
                            label={{
                            value: "0",
                            position: "bottom"
                            }}
                        />
                        </ScatterChart>
                            
                    </div>
                    <div className="col-sm-12 col-lg-3">
                         
                        <div className="table-responsive">
                            <Table>
                            {avgputt.map((teamval) => (  
                                <TableRow>
                                <TableCell> {teamval.x}</TableCell>
                                <TableCell> <strong>{teamval.y+" ("+teamval.xval+")"}</strong></TableCell>
                                </TableRow>
                            ))}     
                        </Table>
                        </div>
                    </div>
                    <div className="col-sm-12 col-lg-4">
                        <ResponsiveContainer width={400} height={300} style={{margin:"1px"}}> 
                            <BarChart data={data1}>
                                <text x={400 / 2} y={5} fill="gray" textAnchor="top" dominantBaseline="central">
                                    <tspan fontSize="12">MISS VALUE</tspan>
                                </text>
                                <XAxis dataKey="x" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}} style={{ fontSize: '0.7rem' }}/>
                                <YAxis hide domain={[0, data1max]}  stroke={ChartConfig.axesColor} />
                                <CartesianGrid vertical={false} horizontal={false} stroke={ChartConfig.chartGridColor} />                                
                                <Bar dataKey="y" fill={"#0066b2"} label={<CustomBarLabel />} barSize={20}/> 
                            </BarChart>
                        </ResponsiveContainer>                            
                    </div>
                    </>
                    }          
                </div>

            </RctCollapsibleCard>
            }  

            
                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ puttperformance}) => {
    const { puttperformancechart, loading } = puttperformance;
    return { puttperformancechart, loading };
   
}


export default connect(mapStateToProps, {
    fetchPuttPerformanceChart,
})(ViewChart);
